<template>
  <div>
    <span v-html="text_body"> </span>
    <router-link class="link" :to="path">
      {{ text_link }}
    </router-link>
  </div>
</template>

<script>
  export default {
    props: {
      path: {
        type: Object,
        required: true
      },
      text_link: {
        type: String,
        required: true
      },
      text_body: {
        type: String,
        required: true
      }
    }
  };
</script>
